import { createAction, createRequestTypes, createRequestActions } from './utils';
export const FETCH_HOME_PAGE_OPTIONS = 'FETCH_HOME_PAGE_OPTIONS';
export const FetchHomePageOptionsActionTypes = createRequestTypes(FETCH_HOME_PAGE_OPTIONS);
export const FetchHomePageOptions = createRequestActions(FetchHomePageOptionsActionTypes);
export const loadHomePageOptions = () => createAction(FETCH_HOME_PAGE_OPTIONS);